import { getLargestZone } from "../shared/layers/utils";
import { getBreaks } from "../shared/map/breaks";
import { cleanupAndRemoveSmallZones, cleanupFeature, cleanupFeatures, cleanupLayer, cleanupPolygon } from "../shared/map/cleanup";
import { ClickHandler } from "../shared/map/clickHandler";
import { createDragSelectInteraction } from "../shared/map/dragselect";
import { DrawMarginContext } from "../shared/map/drawMarginContext";
import { DrawMarginInteraction } from "../shared/map/drawMarginInteraction";
import { createMissingZones, removeOverlaps, trimZoneGeometry } from "../shared/map/edit";
import { EditMode } from "../shared/map/edit/types";
import { MapEditInteraction } from "../shared/map/editInteraction";
import { createGrid, createGridFromExtent } from "../shared/map/grid/grid";
import { insertNewGeometry } from "../shared/map/insert";
import { getExtentForLayers, Layer } from "../shared/map/layer";
import { mergeZones } from "../shared/map/merge";
import { createPictureOverlay } from "../shared/map/pictureOverlay";
import { getLargestPolygon, getPolygons, MinimumZoneArea } from "../shared/map/polygons";
import { RegularShape, RegularShapeEditInteraction, RegularShapeFeature } from "../shared/map/regularShapeEditInteraction";
import { RotateControl } from "../shared/map/rotateControl";
import { MapSelectInteraction } from "../shared/map/selectInteraction";
import { MapSelectInteraction2 } from "../shared/map/selectInteraction2";
import { MapSelectInteraction3 } from "../shared/map/selectInteraction3";
import { splitAlongLine, splitAlongPolygon } from "../shared/map/split";
import { accent, getBaseEditStyle, getDefaultEditStyleFunction, getFeaturePointStyle, getSelectedStrokeStyle, getSelectedStyle, olblue, red } from "../shared/map/styles/defaults";
import { getDefaultMapMarker, getDefaultMapMarkerStyles } from "../shared/map/styles/markers";
import { getTextStyles } from "../shared/map/styles/text";
import { TransformInteraction } from "../shared/map/transformInteraction";
import { checkFeatureInExtent, createFeatures, getExtentDimensions, getExtentsUnion, getFeaturePoints, getGeometryCenter, getGeometryPoints, getLargestPolygonFromArray, getPolygonsAsArray, getRectangleAtLocation, observeOpenlayersObject, setFeatureStyle } from "../shared/map/utils";

export const map = {

    getPolygonsAsArray,
    observeOpenlayersObject,
    getLargestPolygonFromArray,
    createFeatures,
    getPolygons,
    getLargestPolygon,
    getLargestZone,
    cleanupFeature,
    cleanupFeatures,
    cleanupPolygon,
    cleanupLayer,
    splitAlongLine,
    createMissingZones,
    insertNewGeometry,
    cleanupAndRemoveSmallZones,
    mergeZones,
    trimZoneGeometry,
    removeOverlaps,
    createDragSelectInteraction,
    getGeometryCenter,
    getExtentDimensions,
    createPictureOverlay,
    getGeometryPoints,
    getBreaks,
    getFeaturePoints,
    splitAlongPolygon,
    setFeatureStyle,
    getRectangleAtLocation,
    getExtentForLayers,
    checkFeatureInExtent,
    getExtentsUnion,

    MinimumZoneArea,

    Layer,

    MapSelectInteraction,
    MapSelectInteraction2,
    MapSelectInteraction3,
    MapEditInteraction,
    DrawMarginInteraction,
    DrawMarginContext,
    TransformInteraction,
    RotateControl,
    RegularShapeEditInteraction,
    RegularShapeFeature,
    RegularShape,
    ClickHandler,

    styles: {
        getDefaultEditStyleFunction,
        getBaseEditStyle,
        getTextStyles,
        getDefaultMapMarker,
        getDefaultMapMarkerStyles,
        getSelectedStyle,
        getSelectedStrokeStyle,
        getFeaturePointStyle,
        accent,
        red
    },

    edit: {
        EditMode
    },

    grid: {
        createGridFromExtent,
        createGrid
    }
}